import { render } from "./MantenedorCapitulos.vue?vue&type=template&id=835695e8"
import script from "./MantenedorCapitulos.vue?vue&type=script&lang=js"
export * from "./MantenedorCapitulos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__